export enum DonorIntakeAction {
    Divider = -1,
    ViewDetails = 1,
    ViewDetailsNew = 99,
    Edit = 2,
    EditDiagnostics = 3,
    GetPdf = 4,
    LabResults = 5,
    ViewLabResultsDataGenerated = 6,
    ShipJugAndGoToCenter = 7,
    StartPreWorkupLabs = 8,
    ManuallySendRegistrationLink = 9,
    AddPostOpFollowUpDonor = 10,
    TransferDonor = 11,
    CompleteForCandidate = 12,
    ConnectWithDonorMentor = 13,
    MarkJugArrived = 14,
    StartExpertSystem = 15,
    ViewPwlDetails = 16,
    ViewLabOrders = 17,
    UploadLabs = 18,
    ConvertToDirectToCenter = 19,
    RestartPwlJug = 20,
    RestartPwlCystatinC = 21,
    ExpireDonor = 22,
    OptOutDonor = 23,
    RuleOut = 24,
    ReverseRuleOut = 25,
    SendEmail = 26,
    ApplyForDonorShieldReimbursement = 27,
    SendPediatricGalleryEmail = 28,
    AddIntendedMicrositeRecipient = 29
}